import './css/App.css';

import Header from './Header.js'
import Nav from './Nav.js'
import Content from './Content.js'
import Footer from './Footer.js'

import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <div className="app" >
      <Router>
        <Nav />
        <Header />
        <Content />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
